import React from 'react';
import AnimatedSVG from './AnimatedSvg';

function Loader() {
  return (
    <div className="flex min-w-screen min-h-[200px] items-center justify-center">
      <AnimatedSVG />
    </div>
  );
}

export default Loader;
